import { AxiosResponse } from 'axios';
import { Key } from 'react';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { SystemBsSrcReadDTO } from './dto';
import { GetManyPaged, GetManyUnpaged } from './types';

const RESOURCE_PATH = 'systems';

export const getSystems: GetManyPaged<SystemBsSrcReadDTO> = async ({ filter, page, size, sort, config } = {}) =>
    client
        .get(buildPath([RESOURCE_PATH]), {
            ...config,
            params: { filter, page, size, sort, facilityCode: config?.params?.facilityCode },
        })
        .then((response: AxiosResponse) => response.data);

export const getSystemRoots: GetManyUnpaged<
    { ids: Key[] | undefined; facilityCode: string | undefined },
    SystemBsSrcReadDTO
> = async ({ ids, facilityCode, config }) => {
    const path = facilityCode ? [RESOURCE_PATH, 'roots', facilityCode] : [RESOURCE_PATH, 'roots'];
    return client.get(buildPath(path), { ...config, params: { ids } }).then((response: AxiosResponse) => response.data);
};

export const getSystemChildren: GetManyUnpaged<{ code: number }, SystemBsSrcReadDTO> = async ({ code }) =>
    client.get(buildPath([RESOURCE_PATH, code, 'children'])).then((response: AxiosResponse) => response.data);
